// extracted by mini-css-extract-plugin
export default {"SideMenu":"SideMenu_SideMenu__M9RvC"};